const translations = {
    cancel: 'Cancel',
    logService: 'Log service',
    save: 'Save'
};

export default translations;
